import { SelectAllCheckboxChangedEventArgs as SelectAllCheckboxChangedEventArgs_internal } from "./SelectAllCheckboxChangedEventArgs";
import { ensureBool } from "igniteui-react-core";
var IgrSelectAllCheckboxChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrSelectAllCheckboxChangedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrSelectAllCheckboxChangedEventArgs.prototype.createImplementation = function () {
        return new SelectAllCheckboxChangedEventArgs_internal();
    };
    Object.defineProperty(IgrSelectAllCheckboxChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrSelectAllCheckboxChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrSelectAllCheckboxChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrSelectAllCheckboxChangedEventArgs.prototype, "isChecked", {
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrSelectAllCheckboxChangedEventArgs;
}());
export { IgrSelectAllCheckboxChangedEventArgs };
//# sourceMappingURL=igr-select-all-checkbox-changed-event-args.js.map
